import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './styles.scss';
import 'react-table-v6/react-table.css'
import selectTableHOC from "react-table/lib/hoc/selectTable";
import PropTypes from "prop-types";
import Table from "react-table";
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css'
import PlaylistPreviewLink from '../../components/PlaylistPreviewLink';
import { Icon } from '../widgets';
import deleteImg from "signoxe/images/delete.png";
import duplicateImg from "signoxe/images/duplicate.png";
import editImg from "signoxe/images/edit.png";
import previewImg from "signoxe/images/preview.png";
import { Link } from 'react-router-dom/es';
import * as Moment from 'moment';


const SelectTable = selectTableHOC(Table);


class ReportsList extends Component {
  static defaultProps = {
    keyField: "id"
  };

  static propTypes = {
    keyField: PropTypes.string
  };

  static propTypes = {
    reports: PropTypes.array.isRequired,  
    isLoading: PropTypes.array.isRequired,

  };

  generateDate = (data) => {
    return <div>{data.time_stamp && Moment(data.time_stamp).format('YYYY-MM-DD HH:mm')
    }</div>
  }   


  render() {

    const { reports, isLoading } = this.props
    const defaultColumns = [
      {
        Header: () => <div> <i className='fas fa-caret-down mr-1'></i> Name </div>,
        headerStyle: {
          textAlign: 'left',
          border: "1px solid transparent",
          "border-bottom-color": "grey",

        },
        accessor: 'name',
      },
      {
        Header: () => <div> <i className='fas fa-caret-down mr-1'></i> No of Items </div>,
        headerStyle: {
          textAlign: 'left',
          maxWidth: "content",
          border: "1px solid transparent",
          "border-bottom-color": "grey"


        },

      },
      {
        Header: () => <div> <i className='fas fa-caret-down mr-1'></i> Tags </div>,
        headerStyle: {
          textAlign: 'left',
          border: "1px solid transparent",
          "border-bottom-color": "grey",


        },

      },

      {
        Header: () => <div></div>,
        sortable: false,
        filterable: false,

        headerStyle: {
          textAlign: 'left',
          border: "1px solid transparent",
          "border-bottom-color": "grey",


        },




      }
    ]

    const columns = [
      {
        Header: () => <div> <i className='fas fa-caret-down mr-1'></i> User </div>,

        headerStyle: {
          textAlign: 'start',
          border: "1px solid transparent",
          "border-bottom-color": "grey",

        },

        accessor: 'user_details',
        style: {
          textAlign: "left",
          border: "1px solid transparent",

        },
        width:100,
        minWidth:100,
        maxWidth:100

      },
      {
        Header: () => <div> <i className='fas fa-caret-down mr-1'></i> Activity</div>,
        headerStyle: {
          textAlign: 'start',
          border: "1px solid transparent",
          "border-bottom-color": "grey"


        },
        accessor: 'activity',
  

        style: {
          textAlign: "left",
          border: "1px solid transparent",
          'white-space': 'unset' 
        },
        width:500,
        minWidth:300,
        maxWidth:500

      },

      {
        Header: () => <div> <i className='fas fa-caret-down mr-1'></i> Date/Time</div>,
        headerStyle: {
          textAlign: 'start',
          border: "1px solid transparent",
          "border-bottom-color": 
          "grey"


        },
        accessor: 'time_stamp',
        Cell: props => this.generateDate(props.original),

     

        style: {
          textAlign: "start",
          border: "1px solid transparent",
          // width:"10px"

        },

      },
      {
        Header: () => <div> <i className='fas fa-caret-down mr-1'></i> Action</div>,
        headerStyle: {
          textAlign: 'start',
          border: "1px solid transparent",
          "border-bottom-color": "grey"


        },
        accessor: 'action_type',

        style: {
          textAlign: "start",
          border: "1px solid transparent",
          // width:"10px"
        

        },
      

      },

     


     

    ]
    const mobileColumns = [
      {
        Header: () => <div> <i className='fas fa-caret-down mr-1'></i> User </div>,

        headerStyle: {
          textAlign: 'start',
          border: "1px solid transparent",
          "border-bottom-color": "grey",

        },

        accessor: 'user_details',
        style: {
          textAlign: "left",
          border: "1px solid transparent",

        },
        width:100,
        minWidth:100,
        maxWidth:100

      },
      {
        Header: () => <div> <i className='fas fa-caret-down mr-1'></i> Activity</div>,
        headerStyle: {
          textAlign: 'start',
          border: "1px solid transparent",
          "border-bottom-color": "grey"


        },
        accessor: 'activity',
  

        style: {
          textAlign: "left",
          border: "1px solid transparent",
          'white-space': 'unset' 
        },
        width:400,
        minWidth:300,
        maxWidth:500

      },


    ]
    return (
      <React.Fragment>
        {reports && reports.length === 0 ?
          <ReactTable
            columns={defaultColumns}
            defaultPageSize={3}
            noDataText={"Loading Reports .."}
            loading={isLoading}
            showPagination={false}

          />
          :
          <div>
            <div className='hide-for-desktop'>
             
                <ReactTable
                  columns={mobileColumns}
                  data={reports}
                  defaultPageSize={10}
                  noDataText={"Loading User Reports .."}
                  loading={isLoading}

                />

              

            </div>

            <div className='hide-for-mobile'>
              
                <ReactTable
                  columns={columns}
                  data={reports}
                  defaultPageSize={10}
                  noDataText={"Loading User Reports .."}
                  loading={isLoading}

                />

              

            </div>


          </div>

        }
      </React.Fragment>
    )
  }
}



ReportsList.propTypes = {
  reports: PropTypes.array.isRequired,
 

};

export default ReportsList;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/ReportsList/index.js